import stickybits from 'stickybits';

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementsByClassName('js-flybar')[0];

    const init = function() {
        let stickybit, status = false;
        
        const startSticky = function() {
//            console.clear();
//            console.log('start sticky');
            stickybit = stickybits(el, {
	            stickyBitStickyOffset: 40
            });
            status = true;
        }

        const removeSticky = function() {
            console.clear();
            console.log('remove sticky');
            console.log(stickybit);
            stickybit.cleanup();
            status = false;
        }

        const checkWindowWidth = function() {
            if (window.innerWidth >= 768) {
                if (status === false) {
                    startSticky();
                }
                
            } else {
                if (status === true) {
                    removeSticky();
                }
            }
        }

        // Default
        if (window.innerWidth >= 768) {
            startSticky();
        }
        
        window.addEventListener('resize', checkWindowWidth);
    };



    //const stickybitsInstancetoBeCleanedup = stickybits('selector');

    window.addEventListener('load', function() {
        el ? init() : false;
    })    

}, false);
